import {
  ArrowIcon,
  Box,
  Button,
  DestructiveIcon,
  Flex,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Text,
  TextLink,
} from '@modusign/design-system';
import { useDispatch } from 'react-redux';

import { DIGITAL_CERTIFICATE_HELP_URL } from '@app/constants/contractAuthenticationHelpUrl';
import { modalClose } from '@app/store/modal/actions';

interface DigitalCertificateGuideCheckErrorModalProps {
  requesterName: string;
}

function DigitalCertificateGuideCheckErrorModal({
  requesterName,
}: DigitalCertificateGuideCheckErrorModalProps) {
  const dispatch = useDispatch();

  function handleConfirm() {
    dispatch(modalClose());
  }

  return (
    <Box className="Container Container--max-xxs">
      <Flex className="Card Card--pop box-5x align-center" flexDirection="column">
        <ModalTitle direction="column" icon={null}>
          <Flex>
            <DestructiveIcon color="iconPrimaryBase" />
            <Box mt={2}>법인 공동인증서 인증 실패</Box>
          </Flex>
        </ModalTitle>
        <ModalContent textAlign="center">
          <Text as="p" mb={4} textAlign="center" whiteSpace="pre-wrap">
            {requesterName}님이 <br />
            인증을 요청한 번호와 일치하지 않습니다.
          </Text>
          <TextLink href={DIGITAL_CERTIFICATE_HELP_URL} target="_blank">
            해결 방법 안내
            <ArrowIcon direction="right" ml={1} />
          </TextLink>
        </ModalContent>
        <ModalFooter>
          <Button variant="subtle" onClick={handleConfirm}>
            확인
          </Button>
        </ModalFooter>
      </Flex>
    </Box>
  );
}

export default DigitalCertificateGuideCheckErrorModal;
